import { FT_SINGLE, FT_CONDITION_GROUP, FT_AUTOCOMPLETE } from '../FilterTypes';
import {
  CAT_BRANDS,
  SUB_PRODUCTS_VAPING_DEV_ID,
  SUB_PRODUCTS_DHW_DEV_ID,
  SUB_PRODUCTS_WNS_DEV_ID,
} from 'App/utils/Collections';
import {
  searchBandTypes,
  brandTypesLoader,
  searchCompany,
  searchCompetitorsTypes,
  loadCompetitors,
  loadCannaCompetitors,
  searchCannaCompetitors,
} from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  products: {
    name: 'Products',
    groupOrderIndex: 1,
  },
  company: {
    name: 'Company',
    groupOrderIndex: 2,
  },
  competitors: {
    name: 'Competitors',
    groupOrderIndex: 3,
  },
};

export default {
  category: CAT_BRANDS,
  resources: [],
  filters: [
    {
      id: 'id',
      label: 'ID Number',
      type: FT_SINGLE,
      group: groups.general,
      hint: '',
      placeholder: 'Type the Brand ID to search...',
    },
    {
      id: 'and_group_or_products.types',
      propertyName: 'and_group_or_products.types',
      label: 'Product Type',
      group: groups.products,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose type',
      fieldConf: {
        isFavorite: true,
        favoriteKind: 'types',
        searcher: searchBandTypes,
        items: brandTypesLoader,
      },
    },
    {
      id: 'tradingCompanies.id',
      label: 'Trading company',
      type: FT_AUTOCOMPLETE,
      group: groups.company,
      fieldConf: {
        searcher: searchCompany,
      },
    },
    {
      id: 'products.manufacturers.id',
      label: 'Manufacturer',
      type: FT_AUTOCOMPLETE,
      group: groups.company,
      fieldConf: {
        searcher: searchCompany,
      },
    },
    {
      id: 'and_group_or_products.types__comp',
      propertyName: 'and_group_or_products.types',
      label: 'BT & Major Players',
      group: groups.competitors,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose type',
      fieldConf: {
        isFavorite: true,
        favoriteKind: 'types',
        searcher: searchCompetitorsTypes,
        items: loadCompetitors,
      },
      parent: 'and_group_or_products.types',
      childOptions: {
        childItems: loadCompetitors,
      },
      categories: [SUB_PRODUCTS_VAPING_DEV_ID, SUB_PRODUCTS_DHW_DEV_ID, SUB_PRODUCTS_WNS_DEV_ID],
      style: {
        'font-weight': 700,
      },
    },
    {
      id: 'and_group_or_products.types__canna',
      propertyName: 'and_group_or_products.types',
      label: 'Cannabis',
      group: groups.competitors,
      type: FT_CONDITION_GROUP,
      placeholder: 'Choose type',
      fieldConf: {
        isFavorite: true,
        favoriteKind: 'types',
        searcher: searchCannaCompetitors,
        items: loadCannaCompetitors,
      },
      parent: 'and_group_or_products.types',
      childOptions: {
        childItems: loadCannaCompetitors,
      },
      categories: [SUB_PRODUCTS_VAPING_DEV_ID, SUB_PRODUCTS_DHW_DEV_ID, SUB_PRODUCTS_WNS_DEV_ID],
      style: {
        'font-weight': 700,
      },
    },
  ],
  searchBarProp: 'complex_name',
};
